import React from 'react';

import { Table } from '../../../components/elements';

const DataTable = ({ loading, data, history }) => {
  console.log('DataTable...');

  const tableData = data.reduce((p, c) => {
    const temp = [...p];
    // eslint-disable-next-line no-unused-expressions
    c?.menus?.forEach?.(ele => temp.push({ ...ele, place_name: c.place_name }));

    return temp;
  }, []);

  return (
    <>
      <Table>
        <thead>
          <tr>
            <th>
              <div>
                <span>Place Name</span>
              </div>
            </th>
            <th>
              <div>
                <span>Menu Name</span>
              </div>
            </th>
            <th>
              <span>Service Type</span>
            </th>
            <th>
              <span>Status</span>
            </th>
          </tr>
        </thead>

        <tbody>
          {tableData.map(bad => (
            <tr key={bad.slug}>
              <td
                style={{
                  cursor: 'pointer',
                  color: '#00AEEF',
                  whiteSpace: 'nowrap',
                }}
              >
                <span
                  onClick={() => {
                    const newTabUrl = `/update-menu-designer/${bad?.menu_id}`;
                    history.push(newTabUrl);
                  }}
                >
                  {bad.place_name}
                </span>
              </td>
              <td style={{ whiteSpace: 'nowrap' }}>
                <span>{bad.name}</span>
              </td>
              <td style={{ whiteSpace: 'nowrap' }}>
                <span>{bad.service_type}</span>
              </td>
              <td style={{ whiteSpace: 'nowrap' }}>
                <span>{bad.status}</span>
              </td>
            </tr>
          ))}
          <></>
        </tbody>
      </Table>
      {loading && (
        <span
          style={{
            padding: '1rem',
            color: '#00AEEF',
            fontSize: '18px',
          }}
        >
          Loading...
        </span>
      )}
    </>
  );
};

export default DataTable;
